<div [ngClass]="containerClass">
  <div *ngIf="filters" class="row">
    <!-- mobile filters -->
    <div class="col">
      <div class="filter-container filter-container-mobile" [ngClass]="filterWrapperClasses || []">
        <ng-container *ngIf="mobileFilter">
          <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
        </ng-container>
      </div>
    </div>
  </div>
  <div class="row scroll-container-wrapper">
    <!-- sticking filters -->
    <div
      *ngIf="filters?.length && stickyFilters"
      class="col sticky-filter-container"
      [ngClass]="filterWrapperClasses || []"
    >
      <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
    </div>

    <div class="col scroll-container-outer">
      <div class="row scroll-container" #scrollContainer>
        <!-- scrolling filters -->
        <div
          *ngIf="filters?.length && !stickyFilters"
          class="filter-container filter-container-desktop"
          #navContainer
          [ngClass]="filterWrapperClasses || []"
        >
          <ng-container *ngTemplateOutlet="filterTpl"></ng-container>
        </div>
        <!-- 
          this element will show up in the dom but its supposed to be used sticky filters,
          so a placeholder card will be shown behind the filters to calculate the scroll position properly.
        -->
        <div class="mock-offset-card" [ngClass]="placeholderOffsetItemClasses || []"></div>

        <!--
          this card will not show itsetlf and is only meant to calculacte a generic offset to subsctract from
          the current calculated left position.
        -->
        <div class="offset-card" #offsetCard [ngClass]="offsetItemClasses || []"></div>

        <div
          *ngFor="let item of items; let index = index"
          class="card-item-wrapper"
          #cardItem
          [ngClass]="itemWrapperClasses || []"
        >
          <ng-container *ngTemplateOutlet="itemTemplate; context: { item: item, index: index }"></ng-container>
        </div>
      </div>

      <ng-container *ngIf="canLeft">
        <div class="gradient gradient-left" [@fadeInOut]></div>
        <div class="prev-btn" (click)="scrollPrev()" [@fadeInOut]>
          <div class="btn btn-round-l">
            <span class="mb-icon mb-icon-back"></span>
          </div>
        </div>
      </ng-container>
      <ng-container *ngIf="canRight">
        <div class="gradient gradient-right" [@fadeInOut]></div>
        <div class="next-btn" (click)="scrollNext()" [@fadeInOut]>
          <div class="btn btn-round-l">
            <span class="mb-icon mb-icon-forward"></span>
          </div>
        </div>
      </ng-container>
    </div>
  </div>
</div>

<ng-template #filterTpl>
  <div
    *ngFor="let filter of filters; let index = index"
    class="filter-item"
    [class.active]="filter.active"
    [class.disabled]="filter.disabled"
    (click)="setFilter(filter)"
  >
    <span class="filter-item-label copy-l">
      {{ filter.label | translate }}
      <span *ngIf="filter.count" class="mb-badge mb-badge-xxs">{{ filter.count }}</span>
    </span>
  </div>
</ng-template>

<mb-slider-navigation
  *ngIf="activeConfig.showNavigation && (canLeft || canRight)"
  [length]="items.length - (activeConfig.navigationCap || 0)"
  [activeIndex]="activeIndex"
  (indexChange)="slideTo($event)"
  class="navigation"
></mb-slider-navigation>
